import { render, staticRenderFns } from "./kpi-report.vue?vue&type=template&id=221a1633&scoped=true&"
import script from "./kpi-report.vue?vue&type=script&lang=js&"
export * from "./kpi-report.vue?vue&type=script&lang=js&"
import style0 from "./kpi-report.vue?vue&type=style&index=0&id=221a1633&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a1633",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VPagination,VRow})
